import { render, staticRenderFns } from "./RefrenceInfoPopup.vue?vue&type=template&id=60dcea7f"
import script from "./RefrenceInfoPopup.vue?vue&type=script&lang=js"
export * from "./RefrenceInfoPopup.vue?vue&type=script&lang=js"
import style0 from "./RefrenceInfoPopup.vue?vue&type=style&index=0&id=60dcea7f&prod&lang=scss"
import style1 from "./RefrenceInfoPopup.vue?vue&type=style&index=1&id=60dcea7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports